/* eslint-disable no-console */

// ie polyfills
import './app/utils/polyfils';

// load the app
import '@hsbc/evolve-base-assets/dist/styles.css';
import './shell.less';
import './app/components/common.less';
import './assets/manifest/web.json'; // includes web manifest in webpack build
import './app/utils/accessibility-listener'; // adds classes onto body for accessibility
import './app/utils/setup-evolve-runtime'; // initialise the evolve runtime
import {
	showRegionPage,
	showLoginPage,
	showInternalLoginErrorPage,
	showInternalOnboardingPage,
	showExternalOnboardingPage,
	showSympricotPage,
	showCookiePolicyPage,
	showStaffPage,
	showStaffErrorPage
} from './app/utils/globals';

// Application loading flow (in PROD build.  in dev this does not happen.):
// 1 - critical path assets (styles and javascript) are loaded here to allow page to render quickly.
// 2 - service worker is installed (if not already)
// 3 - main app + assets then loaded asynchronously
// 4 - app then loads various views / features asynchronously

const removeInitialShell = () => {
	const el = document.getElementById('remove-me');
	return el && el.parentNode && el.parentNode.removeChild(el);
};

const onLoad = app => {
	const hostElement = document.getElementById('app-bootstrap');
	app.load(hostElement)
		.then(() => {
			removeInitialShell();
		})
		.catch(e => {
			throw e;
		});
};

// decide which page we're going to display
if (showRegionPage()) {
	import('./app/region').then(onLoad);
} else if (showCookiePolicyPage()) {
	import('./app/cookie-policy').then(onLoad);
} else if (showLoginPage()) {
	import('./app/login').then(onLoad);
} else if (showInternalLoginErrorPage()) {
	import('./app/login-error').then(onLoad);
} else if (showInternalOnboardingPage()) {
	import('./app/onboarding-internal').then(onLoad);
} else if (showExternalOnboardingPage()) {
	import('./app/onboarding-external').then(onLoad);
} else if (showSympricotPage()) {
	import('./app/sympricot').then(onLoad);
}
